import { ConsultaSeguimentoPergunta19Model } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-19/model-consultaSeguimentoPergunta19'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoEnum } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { HISTORICO_MCHAT_CALCULATION_STATUS, splitHeaderAndPerguntas } from '../utils-HistoricoMchatRf'

interface HistoricoMChatRfPergunta19Model {
  header: MchatRfAplicacaoQueryModel
  situacoes: MchatRfAplicacaoQueryModel[]
  model: ConsultaSeguimentoPergunta19Model
}

export const convertAplicacaoPergunta19 = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): HistoricoMChatRfPergunta19Model | null => {
  const { header, perguntas: situacoes } = splitHeaderAndPerguntas(aplicacoes, MChatPerguntaEnum.PERGUNTA_19_01)

  if (isUndefinedOrNull(header)) return null

  return {
    header,
    situacoes,
    model: {
      status: HISTORICO_MCHAT_CALCULATION_STATUS,
      PERGUNTA_19_HEADER: booleanToSimNaoEnum(header.stPassou),
      PERGUNTA_19_OLHA_QUANDO_OUVE_BARULHO_ESTRANHO: booleanToSimNaoEnum(
        situacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_19_02)?.stPassou
      ),
      PERGUNTA_19_OLHA_QUANDO_PESSOA_ESTRANHA_APROXIMA: booleanToSimNaoEnum(
        situacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_19_03)?.stPassou
      ),
      PERGUNTA_19_OLHA_QUANDO_VE_ALGO_ESTRANHO_OU_MEDO: booleanToSimNaoEnum(
        situacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_19_04)?.stPassou
      ),
    },
  }
}
